(function () {
  const ecProductCarouselInit = () => {
    $(document).ready(function () {
      $(".js-get-section").each(function (index, parent) {
        let parentId = `#${$(parent).attr("id")}`;

        let sectionElement = document.querySelector(parentId);
        let carousel = sectionElement.querySelector(
          ".js-swiper-ec-product-carousel"
        );
        let pagination = sectionElement.querySelector(
          ".js-swiper-ec-product-carousel-pagination"
        );
        let nextEl = sectionElement.querySelector(
          ".js-swiper-ec-product-carousel-next"
        );
        let prevEl = sectionElement.querySelector(
          ".js-swiper-ec-product-carousel-prev"
        );

        if (!carousel) return;
        if (carousel.swiper) return;

        new Swiper(carousel, {
          slidesPerView: "auto",
          spaceBetween: 16,
          slidesOffsetAfter: 20,
          grabCursor: true,
          simulateTouch: true,
          speed: 600,
          mousewheel: {
            forceToAxis: true,
            sensitivity: 1,
            thresholdDelta: 20,
            thresholdTime: 50,
          },
          pagination: pagination
            ? { el: pagination, clickable: true }
            : false,
          navigation:
            nextEl && prevEl ? { nextEl: nextEl, prevEl: prevEl } : false,
          breakpoints: {
            750: {
              slidesPerView: "auto",
              spaceBetween: 16,
              slidesOffsetAfter: 0,
            },
          },
        });
      });
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    ecProductCarouselInit();
    document.addEventListener("shopify:section:load", function () {
      ecProductCarouselInit();
    });
  });

})();
